module.exports = __webpack_public_path__ + "img/consumer_electronics.02e84532.png";